import config from 'config';
import React from 'react';
import ImportOptionsModal from 'components/ImportOptionsModal';

export const JobsImportOptionsButtons = () => {
  const isProduction = config.is_production;
  
  const sections = [
    {
      title: 'Test Jobs',
      description: 'Import test jobs for development and staging environments.',
      downloadUrl: `${config.rails_url}/v3/admin/development/jobs/download_import_template`,
      downloadFilename: 'medely_test_jobs_import.csv',
      uploadUrl: `${config.rails_url}/v3/admin/development/jobs/import`,
      showCondition: !isProduction,
    },
    {
      title: 'Time Off',
      description: 'Import time off for professionals.',
      downloadUrl: `${config.rails_url}/v3/admin/jobs/time_off/download_import_template`,
      downloadFilename: 'medely_time_off_import.csv',
      uploadUrl: `${config.rails_url}/v3/admin/jobs/time_off/import`,
      showCondition: true, // Always show time off import
    }
  ];

  return <ImportOptionsModal sections={sections} />;
};
